import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import CustomQuerySetupCommonFormComponent from 'webapp/components/custom-query/setup/common/form';
import CustomQuerySetupPossibleWizardComponent from 'webapp/components/custom-query/setup/possible-wizard';

import type CustomQuery from 'webapp/models-custom/custom-query';

import { StepId } from 'webapp/services/wizard';

export default class WizardCreateMetricRouteTemplate extends Component {
	@service('wizard') declare wizardService: Service.Wizard;
	@service('model-manager/custom-queries')
	declare mmCustomQueriesService: Service.ModelManager.CustomQueries;

	@tracked query: CustomQuery | null = null;
	trackingOrigin = 'wizard';

	constructor(owner: Owner, args: object) {
		super(owner, args);
		let query = this.wizardService.createdCustomQuery;
		if (!query) {
			const sourceId = this.wizardService.selectedSpecificSourceId;
			if (sourceId) {
				query = this.mmCustomQueriesService.createNewModel({
					sourceId: +sourceId,
					sourceToId: +sourceId,
				});
			}
		}
		this.query = query || null;
	}

	nextStep() {
		this.wizardService.goToStep(StepId.CREATE_BLOCK);
	}

	goToConnect() {
		this.wizardService.goToStep(StepId.CONNECT);
	}

	@action
	closingQuery(query?: CustomQuery, _isNew = false) {
		if (query?.metric) {
			this.wizardService.createdCustomQuery = query;
			this.nextStep();
		} else {
			if (this.wizardService.createdCustomMetric) {
				this.nextStep();
			} else {
				this.goToConnect();
			}
		}
	}

	<template>
		{{#if this.query.isWizardPossible}}
			<CustomQuerySetupPossibleWizardComponent
				@model={{this.query}}
				@fromWizard={{true}}
				@origin={{this.trackingOrigin}}
				@onFormClose={{this.closingQuery}}
			/>
		{{else}}
			<CustomQuerySetupCommonFormComponent
				@model={{this.query}}
				@fromWizard={{true}}
				@origin={{this.trackingOrigin}}
				@onFormClose={{this.closingQuery}}
			/>
		{{/if}}
	</template>
}
